import { call, takeEvery } from 'redux-saga/effects';

import {
  TRACK_CLICK_ASSETS_TAB,
  TRACK_CLICK_ASSETS_IMAGES_TAB,
  TRACK_RENAME_IMAGE_ASSET,
  TRACK_DELETE_IMAGE_ASSET,
  TRACK_UPLOAD_IMAGE_FROM_HOMEPAGE
} from 'js/actionCreators/trackingActions';

import { track } from '../mixpanelProvider';

function* trackClickAssetsTab() {
  yield call(track, 'Clicked Homepage Assets Tab');
}

function* trackClickAssetsImagesTab() {
  yield call(track, 'Clicked Homepage Assets Images Tab');
}

function* trackRenameImageAsset() {
  yield call(track, 'Renamed Image Asset');
}

function* trackDeleteImageAsset() {
  yield call(track, 'Deleted Image Asset');
}

function* trackUploadImageFromHomepage() {
  yield call(track, 'Uploaded Image From Homepage');
}

export default function* trackAssetsSagas() {
  yield takeEvery(TRACK_CLICK_ASSETS_TAB, trackClickAssetsTab);
  yield takeEvery(TRACK_CLICK_ASSETS_IMAGES_TAB, trackClickAssetsImagesTab);
  yield takeEvery(TRACK_RENAME_IMAGE_ASSET, trackRenameImageAsset);
  yield takeEvery(TRACK_DELETE_IMAGE_ASSET, trackDeleteImageAsset);
  yield takeEvery(TRACK_UPLOAD_IMAGE_FROM_HOMEPAGE, trackUploadImageFromHomepage);
}
